import script from "./BlogList.vue?vue&type=script&setup=true&lang=js"
export * from "./BlogList.vue?vue&type=script&setup=true&lang=js"

import "./BlogList.vue?vue&type=style&index=0&id=5d89cd9a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5d89cd9a"]])

export default __exports__